import { render } from "./LessPain.vue?vue&type=template&id=1a55c93f&scoped=true"
import script from "./LessPain.vue?vue&type=script&lang=js"
export * from "./LessPain.vue?vue&type=script&lang=js"

import "./LessPain.vue?vue&type=style&index=0&id=1a55c93f&scoped=true&lang=css"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a55c93f"]])

export default __exports__